import * as React from 'react';

import { ITheme } from '@fluentui/react/lib/Styling';

import { AppFullGallery, AppGalleryButton, getGalleryWidth } from '@1js/acui-gallery';
import { AppThemeConsumer } from '@1js/acui-theme';

import { AppDirectionalListGalleryButton } from '../AppDirectionalListGalleryButton';
import { AppListGalleryButtonProps } from '../AppListGalleryButton';
import { AppListGalleryProps } from './AppListGallery.Props';
import { galleryButtonDimensions, getGalleryStyles } from './AppListGallery.styles';

export class AppListGallery extends React.PureComponent<AppListGalleryProps, {}> {
  public render() {
    const { columns, defaultWidth, styles } = this.props;
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <AppFullGallery
            {...this.props}
            getGalleryButtonComponent={this.AppListGalleryButton}
            styles={getGalleryStyles(theme, styles)}
            defaultWidth={defaultWidth || getGalleryWidth(columns, galleryButtonDimensions, styles)}
          />
        )}
      </AppThemeConsumer>
    );
  }

  private AppListGalleryButton: React.StatelessComponent<AppListGalleryButtonProps> = React.memo(
    (props: AppListGalleryButtonProps) => {
      return (
        <AppGalleryButton
          {...props}
          automationType={this.props.dataAutomationType || 'AppList'}
          uniqueId={this.props.id}
          shouldTakeFocus={true}
        >
          <AppDirectionalListGalleryButton {...props} rtl={this.props.rtl} multiLevel={this.props.multiLevel} />
        </AppGalleryButton>
      );
    }
  );
}
